export default "__VITE_ASSET__CTTv5zX3__"